import { render, staticRenderFns } from "./microbiology.vue?vue&type=template&id=10254e91&"
import script from "./microbiology.vue?vue&type=script&lang=js&"
export * from "./microbiology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports